@if (onGoingValidation && !onGoingVerification) {
  <ogo-spinner [fullscreen]="true"></ogo-spinner>
}

<div [formGroup]="form" [style.opacity]="onGoingValidation && !onGoingVerification ? 0.6 : 1" class="app-modal-body">
  <div class="row mx-lg-n4">
    <div class="col-xxl-6 px-lg-4">
      <div class="form-group">
        <app-label label="NDD" tooltip="VeuiEntrAdrSit" [required]="true" />
        <div class="form-group form-row">
          <div class="col">
            <input
              id="textInput"
              (paste)="onPasteDomain($event)"
              placeholder="{{ 'RentrezURLSite' | translate }}"
              formControlName="domainName"
              class="form-control"
              type="text"
              #domainName
            />
          </div>
          <div class="col-auto">
            <button
              (click)="checkDns(form.controls.domainName.value)"
              class="btn btn-sm btn-outline-primary"
              [innerHTML]="'CheckDNS' | translate"
              [disabled]="!form.controls.domainName.value?.length"
            ></button>
          </div>
        </div>
      </div>
      <div
        [ngClass]="!(resolveResponse && (resolveResponse | keyvalue)?.length) ? 'disabled-config' : ''"
        class="form-group details resolve"
      >
        <p>
          <b>{{ 'ResolveInfos' | translateLabel }}</b>
        </p>
        <span *ngIf="!resolveResponse" class="text-placeholder resolve" style="margin-left: 0">
          <span class="activity"></span>
        </span>
        @if (resolveResponse && (resolveResponse | keyvalue)?.length) {
          @if (Object.keys(resolveResponse).length == 0) {
            <p>
              {{ 'NoRecord' | translate }}
            </p>
          }
          @if (resolveResponse.cname) {
            <p>
              <strong>{{ 'CNAME' | translateLabel }}</strong>
              <span>&nbsp;{{ resolveResponse.cname }}</span>
            </p>
          }

          @if (resolveResponse?.ipv4?.length) {
            <div class="ips-display">
              <strong>{{ 'IPv4' | translateLabel }}</strong>
              {{ resolveResponse.ipv4.join(', ') }}
            </div>
          }
          @if (resolveResponse?.ipv6?.length) {
            <div class="ips-display">
              <strong>{{ 'IPv6' | translateLabel }}</strong>
              {{ resolveResponse.ipv6.join(', ') }}
            </div>
          }
          @if (
            resolveResponse?.ipv4?.length && resolveResponse.ipv6?.length && cluster && !cluster.supportsIpv6Origins
          ) {
            <div class="warning">
              <i class="icofont icofont-warning resolve-icon warning"></i>
              {{ 'NotIPv6Cluster' | translate }}
            </div>
          }
          @if (resolveResponse?.ipv4?.length === 0 && resolveResponse.ipv6?.length === 0) {
            {{ 'NoRegisterFound' | translate }}
          }
          @if (!resolveResponse.ipv4?.length && resolveResponse.ipv6?.length) {
            <p class="error">
              <i class="icofont icofont-error resolve-icon error" style="top: 3px"></i>
              {{ 'OnlyIPv6OnNotIPv6Cluster' | translate }}
            </p>
          }
        }
      </div>
    </div>
    <div class="col-xxl-6 px-lg-4">
      <div *ngIf="editMode == 'create' && contracts && contracts.totalElements > 1">
        <app-label label="Contract.column" tooltip="Site.contract.tooltip" [required]="true" />
        <ng-select
          [items]="contracts.content"
          bindLabel="name"
          [multiple]="false"
          [addTag]="false"
          [placeholder]="'Site.contract.placeholder' | translate"
          [clearable]="false"
          [searchable]="true"
          formControlName="contract"
        />
      </div>
      <div class="clusters-wrapper">
        <app-label class="cl-primary-label" label="Cluster" tooltip="VeuilSelClust" />

        <div class="clusters-container">
          <div class="clusters">
            <div class="form-group mb-0">
              <select *ngIf="editMode == 'create'" class="form-control" formControlName="cluster">
                @for (c of clusters ?? []; track c.cluster.uid) {
                  <option [ngValue]="c.cluster">{{ c.cluster.name }}</option>
                }
              </select>
              <input
                *ngIf="editMode == 'update' && cluster"
                [value]="cluster.name"
                class="form-control"
                disabled
                type="text"
              />
            </div>

            @if (
              (form.controls.contract.value?.secondaryClusterEnabled && (clusters?.length ?? 0) > 1) ||
              site?.secondaryCluster
            ) {
              <div class="form-group mb-0">
                <app-label label="SecondaryCluster.label" tooltip="SecondaryCluster.help" />
                @if (
                  form.controls.contract.value?.secondaryClusterEnabled && (clusters?.length ?? 0) > 1 && !swapApplied
                ) {
                  <ng-select formControlName="secondaryCluster">
                    @for (c of (clusters ?? []).filter(notPrimaryCluster); track c.cluster.uid) {
                      <ng-option [value]="c.cluster.uid">{{ c.cluster.name }}</ng-option>
                    }
                  </ng-select>
                } @else if (form.controls.secondaryCluster.value) {
                  <input [value]="secondaryClusterName" class="form-control" disabled type="text" />
                }
              </div>
            }
          </div>
          @if (this.form?.controls.secondaryCluster.value) {
            <div *featureFlag="'invertClusters'" class="swap-cluster">
              <div class="sync-control">
                <button
                  (click)="swapClusters()"
                  [disabled]="!canSwapClusters()"
                  [attr.data-title]="'SwapCluster.tooltip' | translate"
                  [title]=""
                  class="instant-tooltip sync-btn"
                  type="button"
                >
                  <i class="icofont icofont-rounded-expand outline-none"></i>
                </button>
              </div>
            </div>
          }
        </div>
      </div>
      <div [className]="secondaryClusterChanged && !swapApplied ? 'warning mt-1' : ' warning mt-1 hidden-tooltip'">
        <i class="icofont icofont-warning resolve-icon warning"></i>
        {{ 'SecondaryCluster.changeWarning' | translate }}
      </div>
      <div class="form-group">
        <div class="flex-align-items" style="gap: 1ex">
          <div class="form-group" style="width: 100%">
            <app-label label="OriginServerIP" tooltip="DestinIsAddSite" [required]="true" />
            <input
              id="proxy"
              placeholder="{{ 'RentrezIPDest' | translate }}"
              formControlName="originServer"
              (paste)="onPasteDestination($event)"
              class="form-control"
              type="text"
            />
          </div>
          <div class="form-group originPort">
            <app-label label="Port" tooltip="PortinIsAddSite" tooltipPlacement="left" />
            <div class="flex-align-items">
              <div class="input-prefix">
                <div style="position: relative; top: 5px">:</div>
              </div>
              <input
                id="originPort"
                [ngStyle]="{ border: form.controls.originPort.value ? '1px solid #7bc5ff' : '' }"
                formControlName="originPort"
                class="form-control"
                type="number"
                placeholder="{{ form.controls.originScheme.value == 'http' ? 80 : 443 }}"
              />
              <button
                id="diagnoseButton"
                (click)="verifyOrigin()"
                [disabled]="
                  !(form.controls.domainName.value && form.controls.originServer.value && cluster) ||
                  onGoingVerification ||
                  onGoingValidation
                "
                class="btn btn-sm btn-outline-primary ml-2"
                style="white-space: nowrap"
                [innerHTML]="'DiagnoseOrigin' | translate"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (displayDiagnose && (primaryDiagnoseResult || secondaryDiagnoseResult)) {
      <div [class.has-issues]="hasDiagIssues" class="col-12 px-lg-4" id="diag-result">
        <ng-container
          [ngTemplateOutletContext]="{ directDisplay: true }"
          [ngTemplateOutlet]="diagnoseModalTpl"
        ></ng-container>
      </div>
    }
  </div>

  <ng-template #diagnoseModalTpl let-directDisplay="directDisplay">
    <div
      [class.single]="
        directDisplay
          ? !form.controls.secondaryCluster.value
          : !($any(primaryDiagnoseResult)?.issueDetected && $any(secondaryDiagnoseResult)?.issueDetected)
      "
      class="diag-results-container"
    >
      @if (directDisplay || $any(primaryDiagnoseResult)?.issueDetected) {
        <fieldset class="col diag-result-col">
          @if (form.controls.secondaryCluster.value) {
            <legend>{{ cluster?.name }}</legend>
          }
          <ng-container
            [ngTemplateOutletContext]="{ result: primaryDiagnoseResult }"
            [ngTemplateOutlet]="diagBlockTpl"
          ></ng-container>
        </fieldset>
      }

      @if (form.controls.secondaryCluster.value && (directDisplay || $any(secondaryDiagnoseResult)?.issueDetected)) {
        <fieldset class="col diag-result-col">
          <legend>{{ secondaryClusterName }}</legend>
          <ng-container
            [ngTemplateOutletContext]="{ result: secondaryDiagnoseResult }"
            [ngTemplateOutlet]="diagBlockTpl"
          ></ng-container>
        </fieldset>
      }
    </div>

    @if (displayConfirmationMessage && !directDisplay) {
      <span class="confirm"> {{ 'ConfirmDiag' | translate }}</span>
    }
  </ng-template>

  <ng-template #diagBlockTpl let-result="result">
    <div *ngIf="result">
      <div *ngIf="$any(result).issueDetected" class="flex-align-items mt-1" style="color: #d28c34">
        <i class="icofont icofont-warning icon-diag mr-2"></i>
        <label> {{ 'SiteMetIssues' | translate }} : </label>
      </div>
      <div *ngIf="!$any(result).issueDetected" class="flex-align-items mt-2" style="color: #0fb10f">
        <i class="icofont icofont-check icon-diag mr-2"></i>
        <label> {{ 'DiagnosticOk' | translate }} : </label>
      </div>
      <div *ngFor="let backend of $any(result).backends | keyvalue" style="text-align: left">
        <div>
          {{ 'DNSResolve' | translate }} :
          <i
            [ngClass]="{
              'icofont-verification-check': $any(backend.value).resolvStatus == 'OK',
              'icofont-warning': $any(backend.value).resolvStatus == 'KO',
            }"
            class="icofont"
          ></i>
        </div>
        <div *ngFor="let ip of $any(backend.value).ips | keyvalue" class="mt-1 text-bottom">
          <b>{{ ip.key }}</b>
          <div class="mt-1 ml-2">
            <div *ngFor="let diag of $any(ip.value) | keyvalue">
              {{ diag.key }} :
              <i
                [ngClass]="{
                  'icofont-verification-check': $any(diag.value).status == 'OK',
                  'icofont-warning': $any(diag.value).status == 'KO',
                }"
                class="icofont"
              ></i>
              <div *ngIf="$any(diag.value).issues?.length" class="mb-2">
                <p>{{ 'DetectedIssues' | translate }} :</p>
                <div *ngFor="let issue of $any(diag.value).issues" class="ml-2">
                  <i>{{ issue }}</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <hr />
  <div class="row mx-lg-n4 separator">
    <div class="col-xxl-6 px-lg-4">
      <div class="form-group row https">
        <app-label class="col" label="ProtocoleEntreUtilisateurEtOGO" tooltip="ForcerEnHttpsDescr" />
        <div class="col-xl-auto">
          <select class="form-control" formControlName="https">
            <option value="http">{{ 'Non' | translate }}</option>
            <option value="https">{{ 'YesWithoutHSTS' | translate }}</option>
            <option value="hsts">{{ 'YesSTS' | translate }}</option>
            <option value="hstss">{{ 'YesSTSIS' | translate }}</option>
            <option value="hstssp">{{ 'YesSTSISP' | translate }}</option>
          </select>
        </div>
      </div>
      <div class="row form-group">
        <app-label class="col" label="ForcerDestinationEn" tooltip="ForceHttps" />
        <div class="col-md-auto">
          <select class="form-control" formControlName="originScheme">
            <option *ngFor="let scheme of UrlSchemes" [value]="scheme">{{ scheme | translate }}</option>
          </select>
        </div>
      </div>
      <div class="row form-group">
        <app-label class="col" label="Site.auditMode.label" tooltip="Site.auditMode.tooltip" />
        <app-switch class="col-md-auto" formControlName="auditMode" />
      </div>
      <div class="row form-group">
        <app-site-tags
          (selectedChange)="form.controls.tags.setValue($event)"
          [selected]="form.controls.tags.value"
          [tags]="tags"
          class="col"
        />
      </div>
    </div>
    <div class="col-xxl-6 px-lg-4">
      <div class="row form-group">
        <app-label class="col" label="Site.removeXForwarded.label" tooltip="Site.removeXForwarded.tooltip" />
        <app-switch class="col-md-auto" formControlName="removeXForwarded" />
      </div>
      <div class="row form-group">
        <app-label label="Site.originSkipCertVerify.label" tooltip="Site.originSkipCertVerify.tooltip" class="col" />
        <app-switch class="col-md-auto" formControlName="originSkipCertVerify" />
      </div>
      <div *ngIf="cluster?.supportsMtls" class="row form-group">
        <app-label label="Site.originMtlsEnabled.label" tooltip="Site.originMtlsEnabled.tooltip" class="col">
          <a
            class="download"
            [href]="STATIC_LINK_OGO_SHIELD_CA_CERT"
            [title]="'Site.originMtlsEnabled.downloadCA' | translate"
            ><i class="icon icon-download"></i>CA</a
          >
        </app-label>
        <app-switch class="col-md-auto" formControlName="originMtlsEnabled" />
      </div>
      <div class="row form-group">
        <app-label label="Site.passthroughMode.label" tooltip="Site.passthroughMode.tooltip" class="col" />
        <app-switch class="col-md-auto" formControlName="passthroughMode" />
      </div>
      <div class="row form-group" *ngIf="canSetMode">
        <fieldset class="col">
          <legend>Admin cluster</legend>
          <div class="row form-group">
            <app-label class="col" label="Mode" tooltip="ModeTooltip" tooltipPlacement="top" />
            <div class="col-md-auto">
              <select #hostMode class="form-control" formControlName="mode">
                <option *ngFor="let m of hostModeService.modes" [value]="m.value">
                  {{ m.label | translate }}
                </option>
              </select>
            </div>
          </div>
        </fieldset>
      </div>

      <div *ngIf="canSetPushLog || showCustomErrorProfile" class="row form-group">
        <fieldset class="col">
          <legend>{{ 'OrgaOwnerOrSiteAdmin' | translate }}</legend>
          <div *ngIf="canSetPushLog" class="row form-group">
            <app-label class="col" label="LogExport" tooltip="LogExportTooltip" />
            <app-switch class="col-md-auto" formControlName="logExportEnabled" />
          </div>
          @if (showCustomErrorProfile) {
            <div class="row form-group">
              <app-label
                class="col"
                label="ErrorHandler.selected"
                tooltip="CustomPagesProfileTooltip"
                tooltipPlacement="top"
              />
              <div class="col-auto">
                <ng-select
                  [addTag]="false"
                  [items]="customPagesProfileModels"
                  [placeholder]="'NoOption' | translate"
                  appendTo="body"
                  bindLabel="name"
                  bindValue="uid"
                  formControlName="customPagesProfile"
                  name="customPagesProfile"
                  style="width: 179px"
                />
              </div>
            </div>
          }
        </fieldset>
      </div>
    </div>
  </div>
  <hr />
  <div class="flex-align-items space-between" style="align-items: flex-start; gap: 1em">
    <div class="setup-guide form-group bg-light mb-0">
      <h6>{{ 'BasculeDns.title' | translate }}</h6>
        @if (!form.controls.secondaryCluster.value) {
          @if (entryPoints) {
            <p class="text-s">
            <span
              [innerHTML]="
                (entryPoints?.ipv6 ? 'BasculeDns.ipv4AndIpv6' : 'BasculeDns.ipv4')
                  | translate: { ipv4: entryPoints?.ipv4, ipv6: entryPoints?.ipv6 }
              "
            ></span>
            </p>
          }
        } @else {
          @if (entryPoints) {
            <p class="text-s">
            <span
              [innerHTML]="
                (entryPoints?.ipv6 ? 'BasculeDns.primary.ipv4AndIpv6' : 'BasculeDns.primary.ipv4')
                  | translate: { ipv4: entryPoints?.ipv4, ipv6: entryPoints?.ipv6 }
              "
            ></span>
            </p>
          }
          @if (secondaryEntryPoints) {
            <p class="text-s">
              <span
                [innerHTML]="
                  (secondaryEntryPoints?.ipv6 ? 'BasculeDns.secondary.ipv4AndIpv6' : 'BasculeDns.secondary.ipv4')
                    | translate: { ipv4: secondaryEntryPoints?.ipv4, ipv6: secondaryEntryPoints?.ipv6 }
                "
              ></span>
            </p>
          }
        }
      <ng-container *ngIf="cluster?.cdnCname && site?.cdn && site?.cdnStatus != 'ACTIVATION_IN_PROGRESS'">
        {{ 'BasculeDns.cdn' | translate }} <strong>{{ site?.cluster?.cdnCname }}</strong>
      </ng-container>
      @let view = outgoingIpsView;

      @for (entry of view.entries; track entry.label) {
        <p>
          {{ entry.label | translateLabel }}
          <strong>{{ entry.ips }}</strong>
        </p>
      }

      @if (view.showPublicLink) {
        <p>
          <a [href]="BACKEND_LINK + 'public-ip-list'" target="_blank"> {{ 'IPsToWhitelist' | translate }}. </a>
        </p>
      }
    </div>
    <div>
      <button
        name="validate-site"
        [disabled]="!canValidate()"
        (click)="editMode === 'create' ? createSite() : updateSite()"
        class="btn btn-sm btn-primary"
        [ngClass]="{ disabled: !canValidate() }"
        [innerHTML]="'valider' | translate"
      ></button>
    </div>
  </div>
</div>
